import type Mithril from 'mithril';
import User from '../models/User';
import username from 'flarum/common/helpers/username';

export default function usernameWithColor(user: User | null | undefined | false): Mithril.Vnode {
  const usernameColorClass = user.attribute("decorationUsernameColor");
  const userUsername = username(user);

  if(user){
    let task = setInterval(function(){
      let usernameDom = userUsername.dom;
      
      if(usernameDom){
        clearInterval(task);

        if(usernameDom.initUsername===undefined){
          usernameDom.initUsername = true;

          $(usernameDom).addClass(usernameColorClass);
        }
      }
    },10);
  }

  return userUsername;
}
